module.exports = __webpack_public_path__ + "img/resultsuccessauto.6a1960da.svg";